import { render, staticRenderFns } from "./CreativeImportEdit.vue?vue&type=template&id=57db1060&scoped=true&"
import script from "./CreativeImportEdit.vue?vue&type=script&lang=ts&"
export * from "./CreativeImportEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db1060",
  null
  
)

export default component.exports